/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { useAuth } from '../../auth'
import { PageMenuLink } from '../../../components/widgets'

const ApplicantPagesMenu: FC = () => {

  const {hasRole} = useAuth()
  return (
    <div className='row'>
      <div className='col-12'>
        <div className='row'>
          <div className='col-lg-6 mb-3'>
            <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>Certification</h4>
            <PageMenuLink title="COC Applications" to='/company/application-management/applications' />
            <PageMenuLink title="Certificates" to='/company/certificate-management/certificates' />
            { (hasRole('Management')) && 
            <>
            <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>Settings</h4>
            <PageMenuLink title="Applicants" to='/company/applicant-management/applicants'         />
            </>
            }

          </div>
          <div className='col-lg-6 mb-3'>
            <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>Site Inspections</h4>
            <PageMenuLink title="Site Inspection Applications" to='/company/doclabel/siteinspection-applications-list' />
            <PageMenuLink title="Inspections List" to='/company/doclabel/siteinspections-list' />

            <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>DOCs</h4>
            <PageMenuLink title="DOC Applications" to='/company/doclabel/doc-applications-list' />
            <PageMenuLink title="DOC List" to='/company/doclabel/doc-list' />

            <h4 className='fs-6 fs-lg-4 text-gray-800 fw-bold mt-3 mb-3 ms-4'>Labels</h4>
            <PageMenuLink title="Label Applications" to='/company/doclabel/label-applications-list' />
            <PageMenuLink title="ROI List" to='/company/doclabel/roi-list' />
            <PageMenuLink title="Label Search" to='/company/doclabel/labels-list' />            
          </div>
        </div>        
      </div>      
    </div>
  )
}

export {ApplicantPagesMenu}
